import { AxiosInstance } from "axios";

import { BaseAPI } from "../../classes/BaseAPI";

export class PatientAPI extends BaseAPI {
  constructor(axios: AxiosInstance) {
    super(axios)
  }
}